import {
    $createTextNode,
    $getRoot,
    EditorConfig,
    LexicalEditor,
    LexicalNode,
    NodeKey,
    ParagraphNode,
    SerializedParagraphNode,
    SerializedTextNode,
} from 'lexical'
import { nanoid } from 'nanoid'
import {
    convertLexicalTextToDBJson,
    SerializedContent,
} from '@/features/screenplay/components/editor/utils/JsonUtils'

export type SerializedParaNode = SerializedParagraphNode & {
    id: string
}

export class ParaNode extends ParagraphNode {
    id: string
    isPdfDebug = import.meta.env.VITE_PDF_DEBUG === 'true'
    static getType(): string {
        return 'para'
    }
    static clone(node: ParaNode): ParaNode {
        return new ParaNode(node.id, node.__key)
    }
    static create(id: string): ParaNode {
        const node = new ParaNode(nanoid())
        node.append($createTextNode(''))
        return node
        //TODO: do we need this $applyNodeReplacement here
        //return $applyNodeReplacement(node)
    }

    constructor(id: string, key?: NodeKey) {
        super(key)
        this.id = id
    }
    createDOM(config: EditorConfig): HTMLElement {
        return this.debugClassAttachedDom()
    }
    createHtmlElement(): HTMLElement {
        const dom = document.createElement('div')
        dom.className = 'para w-full'
        return dom
    }

    debugClassAttachedDom(editor?: LexicalEditor): HTMLElement {
        const dom = this.createHtmlElement()
        if (!this.isPdfDebug) {
            dom.className += ' node-prod'
        }
        return dom
    }

    exportJSON(): SerializedParaNode {
        return {
            ...super.exportJSON(),
            type: this.getType(),
            version: 1,
            id: this.id,
        }
    }

    exportContentJSON(): SerializedContent {
        return {
            type: this.getType(),
            version: 1,
            id: this.id,
            children: this.getChildren().map((child: LexicalNode, index) =>
                convertLexicalTextToDBJson(child.exportJSON() as SerializedTextNode)
            ),
        }
    }

    static importJSON(serializedNode: SerializedParaNode): ParaNode {
        return new ParaNode(serializedNode.id)
    }


    remove(preserveEmptyParent?: boolean): void {
        if ($getRoot().getFirstChild() === this) {
            this.clear()
        } else {
            super.remove()
        }
    }
}
